import React from 'react'
import Breadcrumb from 'app/root/breadcrumb/Breadcrumb'
import PageActions from 'app/protected/roles/common/page-actions/PageActions.js'

interface PageTopProps {
  showActions?: boolean
  actionsConfig?: any[]
}

const PageTop: React.FC<PageTopProps> = ({ showActions, actionsConfig }) => {
  return (
    <div className="flex items-center justify-between m-0">
      <div className="flex items-center text-left">
        <Breadcrumb />
      </div>

      {showActions && actionsConfig && (
        <div className="flex items-center justify-end text-right">
          <PageActions actionsConfig={actionsConfig} />
        </div>
      )}
    </div>
  )
}

export default PageTop
